import {vnTemplate} from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../../valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {imagePickerEdit_template} from "./imagePickerEdit_template";
import {imagePickerAdd_template} from "./imagePickerAdd_template";
import {imagePickerView_template} from "./imagePickerView_template";
import {imagePickerGalleryEdit_template} from "./imagePickerGalleryEdit_template";
import {imagePickerGalleryView_template} from "./imagePickerGalleryView_template";
import {filterDropdown_template} from "../../../../valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {pagination_template} from "../../../../valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {imagePickerBulkEdit_template} from "./imagePickerBulkEdit_template";
import { 
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType } from "../../../../valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { filterTag_template } from "../../../../../../js/components/templates/filterTag_template";
import { validationsList_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var Waypoint: any;

export class imagePicker_template extends vnTemplate {

    public XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlCaller: string;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    private static readonly ONE_DAY = 86400000 // One day in milliseconds

    protected filterSimple: filterSimple_template;
    public imageEdit: imagePickerEdit_template;
    public imagesBulkEdit: imagePickerBulkEdit_template;
    public imageView: imagePickerView_template;
    public imageAdd: imagePickerAdd_template;
    protected galleryEdit: imagePickerGalleryEdit_template;
    protected galleryView: imagePickerGalleryView_template;
    public ratioFilter: filterDropdown_template;
    public orientationFilter: filterDropdown_template;
    public uploadSourceFilter: filterDropdown_template;
    public sortingFilter: filterDropdown_template;
    public imagePagination: pagination_template;
    public galleryPagination: pagination_template;
    protected imageLoadEnable;
    protected galleryLoadEnable;
    protected imageNextpageRequested;
    protected galleryNextpageRequested;
    protected imageHasWaterMarkFilter : filterDropdown_template;
    protected tagFilter: filterTag_template;
    protected validationTemplate: validationsList_template;
    public uploadDateFilter: filterDropdown_template;

    protected getTemplateHtml(): string {

        return /*html*/`
            <div class="w-lightbox w-img-picker " data-bind="css: { 'is-visible': isShown }">

                <div class="lightbox-content img-picker">

                    <div class="img-picker-header w-justify">
                        <div class="w-left">
                            <div class="header-droparea" data-bind="event: { drop: onDropFile }">
                                <button class="btn secondary icon i-image" type="button" data-bind="event: { click: onClickAdd }">Add Image</button>
                            </div>
                            <!--<button class="btn secondary icon i-gallery" type="button">Create Gallery</button>-->
                        </div>
                        <div class="w-center">
                            <span class="picker-header-title icon i-image">Image Picker</span>
                        </div>
                        <div class="w-right">
                        </div>
                        <div class="form-body center-content" style="color:red" data-bind="visible: showPickerUploadError">ERROR OCCURRED UPLOADING FILE</div>
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                    </div>


                    <div class="img-picker-body">

                        <div class="w-last-added"  data-bind="css: { 'is-showing': recentImages().length > 0 }">
                            <h3 class="section-title secondary" data-bind="text: 'Last ' + recentImages().length + ' Added'"></h3>

                            <ul class="img-picker-list last-added" data-bind="foreach: recentImages()" >
                                    <li class="img-picker-item icon" data-bind="css: { 'is-selected': $data.selected && $parent.mode() != 'single-select' }">
                                        <button class="btn-zone view" title="view image" type="button" data-bind="event: { click: $parent.onClickView }"><span>view image</span></button>
                                        <button class="btn-zone select" title="select image" type="button" data-bind="event: { click: $parent.onClickRecentImage }"><span>select image</span></button>
                                        <div class="dropdown">
                                            <!--<button class="btn-icon icon i-option dropdown-toggle" data-bind="event: { click: $parent.onClickListSubMenu.bind($data, 'last_added_parent_') }"><span>options</span></button>-->
                                            <div class="dropdown-list" data-bind="attr: { id : 'last_added_parent_' + $data.id }">
                                                <button class="btn-icon icon i-ins-ind" title="Insert Individually" type="button" data-bind="event: { click: $parent.onClickQuickInsert.bind($parent, '') },  css: { 'is-disable': $parent.mode() == 'multi-select-no-gallery'}"><span>Insert Individually</span></button>
                                                <button class="btn-icon icon i-ins-grid" title="Insert as Grid" type="button" data-bind="event: { click: $parent.onClickQuickInsert.bind($parent, 'grid_view') },  css: { 'is-disable': $parent.mode() == 'single-select' || $parent.mode() == 'multi-select-no-gallery'  }"><span>Insert as Grid</span></button>
                                                <button class="btn-icon icon i-add-to-gallery" title="Add to Group" type="button" data-bind="event: { click: $parent.onClickAddToGallery }, css: { 'is-disable': $parent.mode() == 'single-select' || $parent.mode() == 'multi-select-no-gallery'  }"><span>Add to Group</span></button>
                                                <button class="btn-icon icon i-edit" title="Edit" type="button" data-bind="event: { click: $parent.onClickEdit }"><span>Edit</span></button>
                                                 <!--<div class="dropdown-list sub" >
                                                    <button class="btn-icon icon i-option2" type="button" data-bind="event: { click: $parent.onClickLastAddedSubMenu }"><span>sub-menu</span></button>
                                                    <div data-bind="attr: { id : 'last_added_' + $data.id }">
                                                        <button class="btn-icon accent icon i-delete" title="Delete" type="button" data-bind="event: { click: $parent.onClickDelete }"><span>Delete</span></button>
                                                        <button class="btn-icon icon i-download" title="Download" type="button" data-bind="event: { click: $parent.onClickDownload }"><span>Download</span></button>
                                                        <button class="btn-icon icon i-view" title="View" type="button" data-bind="event: { click: $parent.onClickView }"><span>View</span></button>

                                                    </div>
                                                </div>-->
                                            </div>
                                        </div>
                                        <div class="ratio-content">
                                            <img data-bind="attr: {src: url + '?w=300&h=300', alt: altText }">
                                        </div>
                                    </li>
                                </ul>

                        </div>

                        <div class="list-header w-justify">
                            <div class="w-left">
                                <div class="w-btn-tab">
                                    <button class="btn icon i-image" type="button" data-bind="event: { click: onClickImageTab }, css: { 'is-selected': selectedTab() == 'images' }">Images</button>
                                    <button class="btn icon i-gallery" type="button" data-bind="event: { click: onClickGalleryTab }, css: { 'is-selected': selectedTab() == 'galleries', 'is-disable': mode() == 'single-select' || mode() == 'multi-select-no-gallery'  } ">Groups</button>
                                    <button class="btn icon in-content" type="button" data-bind="event: { click: onClickImagesInContentTab }, css: { 'is-selected': selectedTab() == 'images-in-content' , 'is-disable': mode() == 'single-select' || mode() == 'multi-select-no-gallery' }  ">In Content</button>
                                </div>
                            </div>

                            <div class="w-right" >

                                <div data-bind="visible: selectedTab() == 'images'"><label class="form-label form-label-box">Watermark</label> ${ this.imageHasWaterMarkFilter.getHtmlBuild() } </div>
                                <div data-bind="visible: selectedTab() == 'images'"><label class="form-label form-label-box">Orientation</label> ${ this.orientationFilter.getHtmlBuild() } </div>
                                <div data-bind="visible: selectedTab() == 'images'"><label class="form-label form-label-box">Ratio</label> ${ this.ratioFilter.getHtmlBuild() }</div>
                                <div data-bind="visible: selectedTab() == 'images' && idBrand"><label class="form-label form-label-box">Upload Source</label> ${ this.uploadSourceFilter.getHtmlBuild() }</div>
                                <div data-bind="visible: selectedTab() == 'images'"><label class="form-label form-label-box">Upload Date</label> ${ this.uploadDateFilter.getHtmlBuild() }</div>
                            </div>
                        </div>
                        <div class="w-filters-selected">
                            <div id="filters-selected" class="filters-selected">
                            <div id="selected-tags"></div>
                            <div id="selected-content_types"></div>
                            </div>
                        </div>
                        <div class="list-header w-justify w-sorting">
                            <div class="w-left">
                                <div data-bind="visible: selectedTab() == 'images'" style="min-width: 150px;">${this.tagFilter.getHtmlBuild()}</div>
                            </div>
                            <div class="w-center" data-bind="visible: selectedTab() != 'images-in-content'">
                                ${this.filterSimple.getHtmlBuild()}
                            </div>
                            <div class="w-right">
                                <div class="form-group row" data-bind="">
                                    <select class="small" data-bind="value: orderByAndDirection, event: { change: onChangeSortingFilter },style: { opacity: selectedTab() == 'images-in-content' ? '0' : '1'}">
                                        <option value="dateCreated_DESC">Newest</option>
                                        <option value="dateCreated_ASC">Oldest</option>
                                        <option value="name_ASC">Alphabetical A->Z</option>
                                        <option value="name_DESC">Alphabetical Z->A</option>
                                    </select>
                                </div>
                                <!--<button class="btn-text icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC', 'is-selected' : orderBy() == 'dateCreated' }" type="button">Date Added</button>
                                <button class="btn-text icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC', 'is-selected' : orderBy() == 'name' }" type="button">Name</button>-->
                            </div>

                        </div>
                        <div class="w-img-picker-list " data-bind="style: { display: selectedTab() == 'images' ? 'block' : 'none'}, css : { 'is-short' : isImageViewShown() || isGalleryViewShown() }">

                            <div class="w-img-msg" data-bind="css: { 'is-visible': imageResults().length == 0}">
                                <p>No Image Results Found</p>
                            </div>
                            <ul id="image-results-list" class="img-picker-list search image" data-bind="foreach: imageResults, css: { 'single-picker' : mode() == 'single-select' }">
                                <li class="img-picker-item icon" data-bind="css: { 'is-selected': $data.selected && $parent.mode() != 'single-select' }">

                                    <button class="btn-zone view" title="view image" type="button" data-bind="event: { click: $parent.onClickView }"><span>view image</span></button>
                                    <button class="btn-zone select" title="select image" type="button" data-bind="event: { click: $parent.onClickImage}"><span>select image</span></button>
                                    <div class="dropdown sub" >
                                        <!--<button class="btn-icon icon i-option" data-bind="event: { click: $parent.onClickListSubMenu.bind($data, 'image_list_parent_') }"><span>options</span></button>-->
                                        <div class="dropdown-list" data-bind="attr: { id : 'image_list_parent_' + $data.id }">
                                            <button class="btn-icon icon i-ins-ind" title="Insert Individually" type="button" data-bind="event: { click: $parent.onClickQuickInsert.bind($parent, '') }, css: { 'is-disable': $parent.mode() == 'multi-select-no-gallery' }"><span>Insert Individually</span></button>
                                            <button class="btn-icon icon i-ins-grid" title="Insert as Grid" type="button" data-bind="event: { click: $parent.onClickQuickInsert.bind($parent, $parent.isInsertAsGrid()) }, css: { 'is-disable': $parent.mode() == 'single-select' || $parent.mode() == 'multi-select-no-gallery' }"><span>Insert as Grid</span></button>
                                            <button class="btn-icon icon i-add-to-gallery" title="Add to Group" type="button" data-bind="event: { click: $parent.onClickAddToGallery }, css: { 'is-disable': $parent.mode() == 'single-select' || $parent.mode() == 'multi-select-no-gallery' } "><span>Add to Group</span></button>
                                            <button class="btn-icon icon i-edit" title="Edit" type="button" data-bind="event: { click: $parent.onClickEdit }"><span>Edit</span></button>

                                            <!--<div class="dropdown-list sub ">
                                                <button class="btn-icon icon i-option2" type="button" data-bind="event: { click: $parent.onClickListSubMenu.bind($data, 'image_list_child_') }"><span>sub-menu</span></button>
                                                <div data-bind="attr: { id : 'image_list_child_' + $data.id }">
                                                    <button class="btn-icon accent icon i-delete" type="button" title="Delete" data-bind="event: { click: $parent.onClickDelete }, css: { 'is-disable': $parent.imageIsolderThan24Hours($data) } "><span>Delete</span></button> &lt;!&ndash; the parent content here refer to imagePicker_template (outside the loop) &ndash;&gt;
                                                    <button class="btn-icon icon i-download" title="Download"  type="button" data-bind="event: { click: $parent.onClickDownload }"><span>Download</span></button>
                                                    <button class="btn-icon icon i-view" title="View" type="button" data-bind="event: { click: $parent.onClickView}"><span>View</span></button>
                                                </div>
                                            </div>-->
                                        </div>
                                    </div>
                                    <div class="ratio-content">
                                        <img data-bind="attr: {src: url + '?w=300&h=300', alt: altText }">
                                    </div>
                                </li>
                           </ul>
                        </div>
                        <div class="w-img-picker-list" data-bind="style: { display: selectedTab() == 'galleries' ? 'block' : 'none'}, css : { 'is-short' : isImageViewShown() || isGalleryViewShown() }">
                           <div class="w-img-msg" data-bind="css: { 'is-visible': galleryResults().length == 0}">
                                <p>No Group Results Found</p>
                           </div>
                           <ul id="gallery-results-list" class="img-picker-list search gallery" data-bind="foreach: galleryResults">
                             <li class="img-picker-item icon" data-bind="css: { 'is-selected': $data.selected }">
                                <button class="btn-zone view" title="view gallery" type="button" data-bind="event: { click: $parent.onClickViewGallery }"><span>view group</span></button>
                                <button class="btn-zone select" title="select gallery" type="button" data-bind="event: { click: $parent.onClickGallery }"><span>select group</span></button>
                                <div class="dropdown">
                                    <!--<button class="btn-icon icon i-option dropdown-toggle" data-bind="event: { click: $parent.onClickListSubMenu.bind($data, 'image_list_parent_') }"><span>options</span></button>-->
                                    <div class="dropdown-list" data-bind="attr: { id : 'image_list_parent_' + $data.id }">
                                        <button class="btn-icon icon i-ins-ind" data-bind="event: { click: $parent.onClickInsertGalleryImagesIndividually.bind($parent) }" title="Insert individually" type="button"><span>Insert Individually</span></button>
                                        <button class="btn-icon icon i-ins-gallery" title="Insert as Gallery" type="button" data-bind="event: { click: $parent.onClickInsertGallery.bind($parent, '') }, css:{'is-disable': $data.images.length == 1}"><span>Insert as Gallery</span></button>
                                        <button class="btn-icon icon i-ins-grid" title="Insert as Grid" type="button" data-bind="event: { click: $parent.onClickInsertGallery.bind($parent, $parent.isInsertAsGrid()) }"><span>Insert as Grid</span></button>
                                        <button class="btn-icon icon i-edit" title="Edit" type="button" data-bind="event: { click: $parent.onClickEditGallery }"><span>Edit</span></button>
                                        <!--
                                        <div class="dropdown-list sub ">
                                            <button class="btn-icon icon i-option2" type="button" data-bind="event: { click: $parent.onClickListSubMenu.bind($data, 'image_list_child_') }"><span>sub-menu</span></button>
                                            <div data-bind="attr: { id : 'image_list_child_' + $data.id }">
                                                <button class="btn-icon icon i-view" title="View" type="button" data-bind="event: { click: $parent.onClickViewGallery }"><span>View</span></button>
                                            </div>
                                        </div>
                                        -->
                                         <!--<button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>--->
                                    </div>
                                </div>
                                <div class="ratio-content gallery" data-bind="foreach: $data.images.slice(0,4)">
                                    <div><img data-bind="attr: {src: url + '?w=300&h=300', alt: '' }"></div>
                                </div>
                            </li>
                          </ul>
                          <div id="gallery-results"></div>
                       </div>
                       <div id="in-content-list" class="w-img-picker-list " data-bind="style: { display: selectedTab() == 'images-in-content' ? 'block' : 'none'}, css : { 'is-short' : isImageViewShown() || isGalleryViewShown() }">

                            <div class="w-img-msg" data-bind="css: { 'is-visible': imagesInContent().length == 0}">
                                <p>No Images in Content Found</p>
                            </div>
                            <ul class="img-picker-list search image" data-bind="foreach: imagesInContent, css: { 'single-picker' : mode() == 'single-select' }">

                                <li class="img-picker-item icon" data-bind="css: { 'is-selected': $data.selected && $parent.mode() != 'single-select' }">
                                    <button class="btn-zone view" title="view image" type="button" data-bind="event: { click: $parent.onClickView}"><span>view image</span></button>
                                    <button class="btn-zone select" title="select image" type="button" data-bind="event: { click: $parent.onClickImage}"><span>select image</span></button>
                                    <div class="dropdown">
                                        <!--<button class="btn-icon icon i-option dropdown-toggle" data-bind="event: { click: $parent.onClickListSubMenu.bind($data, 'in_content_list_parent_') }"><span>options</span></button>-->
                                        <div class="dropdown-list" data-bind="attr: { id : 'in_content_list_parent_' + $data.id }">
                                            <button class="btn-icon icon i-ins-ind" title="Insert individually" type="button" data-bind="event: { click: $parent.onClickQuickInsert.bind($parent, '') }"><span>Insert individually</span></button>
                                            <button class="btn-icon icon i-ins-grid" title="Insert as Grid" type="button" data-bind="event: { click: $parent.onClickQuickInsert.bind($parent, $parent.isInsertAsGrid()) }"><span>Insert as Grid</span></button>
                                            <button class="btn-icon icon i-add-to-gallery" title="Add to Group" type="button" data-bind="event: { click: $parent.onClickAddToGallery }, visible: $parent.mode() != 'single-select'"><span>Add to Group</span></button>
                                            <button class="btn-icon icon i-edit" title="Edit" type="button" data-bind="event: { click: $parent.onClickEdit }"><span>Edit</span></button>

                                            <!--<div class="dropdown-list sub ">
                                                <button class="btn-icon icon i-option2" type="button" data-bind="event: { click: $parent.onClickListSubMenu.bind($data, 'in_content_list_child_') }"><span>sub-menu</span></button>
                                                <div data-bind="attr: { id : 'in_content_list_child_' + $data.id }">
                                                    <button class="btn-icon accent icon i-delete" type="button" title="Delete" data-bind="event: { click: $parent.onClickDelete }"><span>Delete</span></button>
                                                    <button class="btn-icon icon i-download" title="Download"  type="button" data-bind="event: { click: $parent.onClickDownload }"><span>Download</span></button>
                                                    <button class="btn-icon icon i-view" title="View" type="button" data-bind="event: { click: $parent.onClickView }"><span>View</span></button>

                                                </div>
                                            </div>-->
                                        </div>
                                    </div>
                                    <div class="ratio-content">
                                        <img data-bind="attr: {src: url + '?w=300&h=300', alt: altText }">
                                    </div>
                                </li>
                           </ul>
                        </div>
                    </div>

                    ${this.galleryView.getHtmlBuild()}
                    ${this.galleryEdit.getHtmlBuild()}
                    ${this.imageView.getHtmlBuild()}
                    ${this.imageEdit.getHtmlBuild()}
                    ${this.imagesBulkEdit.getHtmlBuild()}
                    ${this.imageAdd.getHtmlBuild()}

                    <div class="w-selection-panel " data-bind="css: { 'is-visible': ( (selectedImages() && selectedImages().length > 0) || selectedGallery() != null) && mode() != 'single-select' , 'is-closed' : !isSelectionShown() }"><!-- is-visible -->
                        <button class="btn-selection-minimize icon i-dropdown-simple" type="button" data-bind="event: { click: onClickMinimizeSelectionPanel }, css: { 'is-closed' : !isSelectionShown() }"></button>
                        <div class="selection-panel img" data-bind="visible: selectedImages() && selectedImages().length > 0">
                            <div class="selection-panel-header">

                               <strong class="icon i-image" data-bind="text: 'Selected images (' + (selectedImages() && selectedImages().length ? selectedImages().length : 0) + ')'"></strong>

                                 <div style="display: flex;align-items: center">
                                     <div class="insert-dropdown">
                                        <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button"><span>Insert</span></button>
                                        <div class="insert-dropdown-list">
                                            <button class="btn-icon icon i-ins-ind" type="button" data-bind="event: { click: onClickInsertImageGroupTag.bind() }, css: { 'is-disable': mode() != 'multi-select-no-gallery' }" title="Insert" type="button"><span>Insert</span></button>
                                            <!-- ko if: mode() != 'multi-select-no-gallery' -->
                                                <button class="btn-icon icon i-ins-ind" type="button" data-bind="event: { click: onClickInsertIndividually.bind() }, css: { 'is-disable': mode() == 'multi-select-no-gallery' }" title="Insert Individually" type="button"><span>Insert Individually</span></button>
                                                <button class="btn-icon icon i-ins-gallery" data-bind="event: { click: onClickInsertAll.bind($data, '', 'group') }, css: { 'is-disable': (selectedImages().length == 1)}, css: { 'is-disable': mode() == 'multi-select-no-gallery' }" title="Insert as Gallery" type="button"><span>Insert as Gallery</span></button>
                                                <button class="btn-icon icon i-ins-grid" data-bind="event: { click: onClickInsertAll.bind($data, isInsertAsGrid(), 'group' ) }, css: { 'is-disable': mode() == 'multi-select-no-gallery' }" title="Insert as Grid" type="button"><span>Insert as Grid</span></button>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                    <button class="btn-icon icon i-add-to-gallery" title="Add to Group" type="button" data-bind="event: { click: onClickAddToGalleryAll }, attr: { title: selectedGallery() == null ? 'Add To New Group' : 'Add To Selected Gallery'}, css: { 'is-disable': mode() == 'multi-select-no-gallery' }"><span>Add to Group</span></button>
                                    <button class="btn-icon icon i-deselect" title="Deselect all" type="button" data-bind="event: { click: onClickDeselectAll }"><span>Deselect all</span></button>
                                </div>
                                <!--
                                <div class="dropdown">
                                    <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                    <div class="dropdown-list">
                                        <div class="btn-icon-joint">
                                            <button class="btn-icon icon i-insert" title="Insert" type="button" data-bind="event: { click: onClickInsertAll.bind($data, '') }"><span>Insert</span></button>
                                            <button class="btn-icon icon i-insert-grid" title="Insert as grid" type="button" data-bind="event: { click: onClickInsertAll.bind($data, isInsertAsGrid() ) }"><span>Insert all as grid</span></button>
                                        </div>
                                        <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button" data-bind="event: { click: onClickAddToGalleryAll }, attr: { title: selectedGallery() == null ? 'Add To New Gallery' : 'Add To Selected Gallery'}"><span>Add to Gallery</span></button>
                                        <button class="btn-icon icon i-deselect" title="Deselect all" type="button" data-bind="event: { click: onClickDeselectAll }"><span>Deselect all</span></button>
                                    </div>

                                </div>
                                -->
                            </div>
                            <div class="selection-panel-body">
                                <button class="btn-selected btn-preview is-active" type="button" data-bind="event: { click: onClickScrollLeft.bind(this, 'selected-images') }, style: { opacity: isImageArrowsShown() ? '1' : '0'}"><span class="hide">previous</span></button>
                                <ul class="img-picker-list selected" data-bind="foreach: selectedImages()" id="selected-images">
                                    <li class="img-picker-item">
                                       <button class="btn icon i-deselect" type="button" data-bind="event: { click: $parent.onClickRemoveSelectedImage }"></button>
                                        <div class="ratio-content">
                                            <img data-bind="attr: {src: url + '?w=300&h=300', alt: altText }">
                                        </div>
                                    </li>
                                </ul>
                                <button class="btn-selected btn-next is-active" type="button" data-bind="event: { click: onClickScrollRight.bind(this, 'selected-images') }, style: { opacity: isImageArrowsShown() ? '1' : '0'}"><span class="hide">next</span></button>
                            </div>
                        </div>
                        <!-- ko if: selectedGallery() != null -->
                        <div class="selection-panel gallery">
                            <div class="selection-panel-header gallery">
                                <div class="selection-panel-header-title" style="display: flex; gap: 8px; align-items: center">
                                    <strong class="icon i-gallery" data-bind="text: selectedGallery().name + ' (' + selectedGallery().images.length + ' images)'"></strong>
                                    <span class="unsaved icon i-save" data-bind="visible: selectedGallery().unsaved">Unsaved changes</span>
                                </div>

                                <div style="display: flex;align-items: center">
                                     <div class="insert-dropdown">
                                        <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button"><span>Insert</span></button>
                                        <div class="insert-dropdown-list">
                                            <button class="btn-icon icon i-ins-ind" type="button" data-bind="event: { click: onClickInsertGalleryImagesIndividually.bind($data, selectedGallery())}" title="Insert Individually" type="button"><span>Insert Individually</span></button>
                                            <button class="btn-icon icon i-ins-gallery" data-bind="event: { click: onClickInsertGallery.bind($data, '' ) }" title="Insert as Gallery" type="button"><span>Insert as Gallery</span></button>
                                            <button class="btn-icon icon i-ins-grid" data-bind="event: { click: onClickInsertGallery.bind($data, isInsertAsGrid()) }" title="Insert as Grid" type="button"><span>Insert as Grid</span></button>
                                        </div>
                                    </div>
                                    <button class="btn-icon icon i-view" title="View" type="button" data-bind="event: { click: onClickViewGallery }"><span>View</span></button>
                                    <button class="btn-icon icon i-cancel" title="Cancel" type="button" data-bind="event: { click: onClickCancelGallery }"><span>Cancel</span></button>
                                    <button class="btn-icon icon i-save" title="Save" type="button" data-bind="event: { click: onClickSaveGallery }"><span>Save</span></button>
                                    <button class="btn-icon icon i-edit" title="Edit" type="button" data-bind="event: { click: onClickEditGallery }"><span>Edit</span></button>
                                    <button class="btn-icon icon i-deselect" title="Deselect" type="button" data-bind="event: { click: onClickDeselectGallery }"><span>Deselect</span></button>
                                </div>
                                <!--
                                <div class="dropdown">
                                    <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                    <div class="dropdown-list">
                                        <div class="btn-icon-joint">
                                            <button class="btn-icon icon i-insert" title="Insert" type="button" data-bind="event: { click: onClickInsertGallery.bind($data, '' ) }"><span>Insert</span></button>
                                            <button class="btn-icon icon i-insert-grid" title="Insert as grid" type="button" data-bind="event: { click: onClickInsertGallery.bind($data, isInsertAsGrid()) }"><span>Insert as grid</span></button>
                                         </div>


                                    </div>

                                </div>
                                -->
                            </div>
                             <div class="selection-panel-body" >
                                <button class="btn-selected btn-preview is-active" type="button" data-bind="event: { click: onClickScrollLeft.bind(this, 'selected-gallery') }, style: { opacity: isGalleryArrowsShown() ? '1' : '0'}"><span class="hide">previous</span></button>
                                <ul class="img-picker-list selected" data-bind="foreach: selectedGallery().images" id="selected-gallery">
                                    <li class="img-picker-item icon" data-bind="css: { 'i-save': $data.unsaved }"><!-- add .i-save when the img is new and the gallery not saved -->
                                        <button class="btn icon i-close" type="button" data-bind="event: { click: $parent.onClickRemoveGalleryImage }"></button>
                                        <div class="ratio-content">
                                            <img data-bind="attr: {src: url + '?w=300&h=300', alt: altText }">
                                            <!--<button class="btn no-bg icon i-delete" type="button" data-bind="event: { click: $parent.onClickDeleteSelection }"></button>-->
                                        </div>
                                    </li>
                                </ul>
                                <button class="btn-selected btn-next is-active" type="button" data-bind="event: { click: onClickScrollRight.bind(this, 'selected-gallery') }, style: { opacity: isGalleryArrowsShown() ? '1' : '0'}"><span class="hide">next</span></button>
                            </div>
                        </div>
                        <!-- /ko -->
                   </div>
                </div>

            </div>
            `;
    }

    public showLoading(){
        let lists = document.getElementsByClassName("w-img-picker-list");
        for(let list of lists){
            list.classList.add("loading");
        }
    }

    public showInContentLoading(){
        let list = document.getElementById("in-content-list");
        list.classList.add("loading");
    }

    public hideInContentLoading(){
        let list = document.getElementById("in-content-list");
        list.classList.remove("loading");
    }


    public hideLoading(){
        let lists = document.getElementsByClassName("w-img-picker-list");
        for(let list of lists){
            list.classList.remove("loading");
        }

    }

    private onLoadTemplate () {
        let dropArea = document.getElementById("drop-area");

        // Prevent default drag behaviors
        ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, preventDefaults, false)
            document.body.addEventListener(eventName, preventDefaults, false)
        });

        ;['dragenter', 'dragover'].forEach(eventName => {
            dropArea.addEventListener(eventName, highlight, false)
        });

        ;['dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, unhighlight, false)
        });

        //dropArea.addEventListener('drop', this.handleDrop2, false);

        function highlight(e) {
            dropArea.classList.add('highlight');
        }

        function unhighlight(e) {
            dropArea.classList.remove('highlight');
        }

        function preventDefaults (e) {
            e.preventDefault();
            e.stopPropagation();
        }

    }

    public getViewModelForRequest(){

        return {
            filters      : {
                keywords: this.getTemplateViewModel().filterSimple.filterKeyword,
                ratio: this.getTemplateViewModel().ratioFilter.selectedOption,
                orientation: this.getTemplateViewModel().orientationFilter.selectedOption,
                uploadSource: this.getTemplateViewModel().uploadSourceFilter.selectedOption,
                watermark: this.getTemplateViewModel().imageHasWaterMarkFilter.selectedOption,
                tags: this.tagFilter.getTagsForRequest(),
                uploadDate: this.uploadDateFilter.getSelectedOption()
            },
            imagePagination: this.getTemplateViewModel().imagePagination,
            galleryPagination: this.getTemplateViewModel().galleryPagination,
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection
        }
    }

    protected initPartial(): void {

        this.filterSimple = new filterSimple_template("filterSimple", this.getTemplateViewModel(), this);

        this.imageEdit = new imagePickerEdit_template("imageEdit", this.getTemplateViewModel(), this.caller);
        this.imageEdit.setParent(this);

        this.imagesBulkEdit = new imagePickerBulkEdit_template("imagesBlukEdit", this.getTemplateViewModel(), this.caller);
        this.imagesBulkEdit.setParent(this);

        this.imageView = new imagePickerView_template("imageView", this.getTemplateViewModel(), this.caller);
        this.imageView.setParent(this);

        this.imageAdd = new imagePickerAdd_template("imageAdd", this.getTemplateViewModel(), this.caller);

        this.galleryEdit = new imagePickerGalleryEdit_template("galleryEdit", this.getTemplateViewModel(), this.caller);
        this.galleryEdit.setParent(this);

        this.galleryView = new imagePickerGalleryView_template("galleryView", this.getTemplateViewModel(), this.caller);
        this.galleryView.setParent(this);

        this.ratioFilter = new filterDropdown_template("ratioFilter", this.getTemplateViewModel(), this);
        this.ratioFilter.setLabel("Ratio");

        this.orientationFilter = new filterDropdown_template("orientationFilter", this.getTemplateViewModel(), this);
        this.orientationFilter.setLabel("Orientation");

        this.uploadSourceFilter = new filterDropdown_template("uploadSourceFilter", this.getTemplateViewModel(), this);
        this.uploadSourceFilter.setLabel("Upload Source");

        this.galleryPagination = new pagination_template("galleryPagination", this.getTemplateViewModel(), this.caller);
        this.galleryPagination.getTemplateViewModel().itemPerPage = 54 ;

        this.imagePagination = new pagination_template("imagePagination", this.getTemplateViewModel(), this.caller);
        this.imagePagination.getTemplateViewModel().itemPerPage = 54 ;

        this.imageHasWaterMarkFilter = new filterDropdown_template('imageHasWaterMarkFilter', this.getTemplateViewModel(), this);
        this.imageHasWaterMarkFilter.setLabel("WaterMark")
        this.imageHasWaterMarkFilter.setOptions([{id : 0, name: 'All'}, {id : 1, name: 'Yes'}, {id : 2, name: 'No'}]);

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this);
        this.tagFilter.asMultipleSelectionMode();

        this.uploadDateFilter = new filterDropdown_template("uploadDateFilter", this.getTemplateViewModel(), this);
        this.uploadDateFilter.setLabel("Ratio");
        this.uploadDateFilter.setOptions([
            { id: 0, name: 'All', score: null , value: null },
            { id: 1, name: 'Last 24 hours', score: Math.floor(Date.now() / 1000) - 86400, value: '1 day ago' },
            { id: 2, name: 'Last Week', score: Math.floor(Date.now() / 1000) - (86400 * 7), value: '1 week ago' },
            { id: 3, name: 'Last Month', score: Math.floor(Date.now() / 1000) - (86400 * 30), value: '1 month ago' }
        ]);

    }

    protected getTemplateName(): string {
        return "imagePicker-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return [];
    }

    protected buildViewModel(): any {

        // Must be defined to avoid error in vnModule_knockoutJS
        this.validationTemplate = this.caller.validationTemplate;

        // create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) // create new item
            }
        }


        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            idBrand: ko.observable(null),
            isShown: ko.observable(false),
            mode: ko.observable("multi-select"),
            mustInsertInGallery: ko.observable(true),
            target: ko.observable(null),
            isSelectionShown: ko.observable(true),
            selectedImage: ko.observable(null),
            selectedGallery: ko.observable(null),
            originalSelectedGallery: ko.observable(null),
            selectedImages: ko.observableArray([]),
            selectedImagesMarkup: ko.observable(''),
            name: ko.observable(null),
            idImage: ko.observable(null),
            caption: ko.observable(null),
            description: ko.observable(null),
            altText: ko.observable(null),
            selectedTab: ko.observable("images"),
            imageResults: ko.observableArray([]),
            imagesInContent: ko.observableArray([]),
            recentImages: ko.observableArray([]),
            numberOfRecentImages: ko.observable(30),
            galleryResults: ko.observableArray([]),
            orderBy: ko.observable("dateCreated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            isGalleryArrowsShown: ko.observable(false),
            isImageArrowsShown: ko.observable(false),
            permissions: ko.observableArray(this.initPermissions(['article_edit_embargo'])),
            showPickerUploadError: ko.observable(false),
            isImageOptimizable:  ko.observable(false),
            onClickCancel: function(data, event){ huit_neuf_this.onClickCancel();},
            onClickMinimizeSelectionPanel: function(data, event){ huit_neuf_this.onClickMinimizeSelectionPanel();},
            onClickAdd: function(data, event){ huit_neuf_this.onClickAdd();},
            onLoadTemplate: function(data, event){ huit_neuf_this.onLoadTemplate();},
            onClickInsert: function(data, event){ huit_neuf_this.onClickInsert(data);},
            onClickInsertGallery: function(param,data, event){ huit_neuf_this.onClickInsertGallery(param, data);},
            onClickSaveGallery: function(data, event){ huit_neuf_this.onClickSaveGallery(data);},
            onClickCancelGallery: function(data, event){ huit_neuf_this.onClickCancelGallery(data);},
            onDropFile: function(data, event){ huit_neuf_this.onDropFile(event);},
            onClickImage: function(data, event){ huit_neuf_this.onClickImage(data);},
            onClickGallery: function (data, event){ huit_neuf_this.onClickGallery(data);},
            onClickRecentImage: function(data, event){ huit_neuf_this.onClickRecentImage(data);},
            onClickEdit: function(data, event){ huit_neuf_this.onClickEdit(data);},
            onClickEditGallery: function(data, event){ huit_neuf_this.onClickEditGallery(data);},
            onClickViewGallery: function(data, event){ huit_neuf_this.onClickViewGallery(data);},
            onClickDeselectGallery: function(data, event){ huit_neuf_this.onClickDeselectGallery();},
            onClickView: function(data, event){ huit_neuf_this.onClickView(data);},
            onAddFiles: function(data, event, files){ huit_neuf_this.onAddFiles(event);},
            onClickRemoveSelectedImage: function(data, event, files){ huit_neuf_this.onClickRemoveSelectedImage(data);},
            onClickRemoveGalleryImage: function(data, event, files){ huit_neuf_this.onClickRemoveGalleryImage(data);},
            onClickReorder: function (value, data, event){ huit_neuf_this.onClickReorder(value, data, event);},
            onClickImageTab: function (value, data, event){ huit_neuf_this.onClickImageTab();},
            onClickGalleryTab: function (value, data, event){ huit_neuf_this.onClickGalleryTab();},
            onClickImagesInContentTab: function (value, data, event){ huit_neuf_this.onClickImagesInContentTab();},
            onClickQuickInsert: function(param, data, event){ huit_neuf_this.onClickQuickInsert(param, data);},
            onClickListSubMenu: function(value, data, event){ huit_neuf_this.onClickListSubMenu(data, value);},
            onClickLastAddedSubMenu: function(data, event){ huit_neuf_this.onClickLastAddedSubMenu(data);},
            onClickDeselectAll: function(data, event){ huit_neuf_this.onClickDeselectAll();},
            onClickInsertAll: function(param, data, event){ huit_neuf_this.onClickInsertAll(param, data);},
            onClickInsertIndividually: function(param, data, event){ huit_neuf_this.onClickInsertIndividually();},
            onClickInsertImageGroupTag: function(param, data, event){ huit_neuf_this.onClickInsertImageGroupTag(param, data);},
            onClickInsertGalleryImagesIndividually: function(data, event){ huit_neuf_this.onClickInsertGalleryImagesIndividually(data);},
            onClickDownload: function(data, event){ huit_neuf_this.onClickDownload(data);},
            onClickAddToGallery: function(data, event){ huit_neuf_this.onClickAddToGallery(data);},
            onClickAddToGalleryAll: function(data, event){ huit_neuf_this.onClickAddToGalleryAll();},
            onClickDelete: function(data, event){ huit_neuf_this.onClickDelete(data);},
            onClickScrollLeft: function (value, data, event){ huit_neuf_this.onClickScrollLeft(value);},
            onClickScrollRight: function (value, data, event){ huit_neuf_this.onClickScrollRight(value);},
            onChangeSortingFilter: function (data, event){ huit_neuf_this.onChangeSortingFilter(data,event);},
            isImageViewShown: function (data, event){ return huit_neuf_this.imageView.getIsShown();},
            isGalleryViewShown: function (data, event){ return huit_neuf_this.galleryView.getIsShown();},
            isInsertAsGrid: function (data, event){ return huit_neuf_this.isInsertAsGrid();},
            imageIsolderThan24Hours: function (data, event){ return huit_neuf_this.imageIsolderThan24Hours(data);},
        };
    }

    public onChangeSortingFilter(data, event){

        if (event.target.value.includes("DESC")) {
            data.orderByDirection("DESC");
        }else{
            data.orderByDirection("ASC");
        }

        if (event.target.value.includes("name")) {
            data.orderBy("name");
        }else{
            data.orderBy("dateCreated");
        }

        this.resetPagination();

        this.caller.getImageData();
        this.caller.getGalleryData();
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.resetPagination();
        this.caller.getImageData();
        this.caller.getGalleryData();
    }

    protected resetPagination(){

        this.getTemplateViewModel().imagePagination.pageNumber(1);
        this.getTemplateViewModel().galleryPagination.pageNumber(1);
        this.getTemplateViewModel().imageResults([]);
        this.imageLoadEnable = null;
        this.galleryLoadEnable = null;
        this.getTemplateViewModel().galleryResults([]);
        this.getTemplateViewModel().imagePagination.reuseTotalCount = false;
    }

    protected resetFilter() {

        this.getTemplateViewModel().filterSimple.filterInputClearButton(0);
        this.getTemplateViewModel().filterSimple.filterKeyword("");
        this.getTemplateViewModel().ratioFilter.selectedOption(null);
        this.getTemplateViewModel().orientationFilter.selectedOption(null);
        this.getTemplateViewModel().uploadSourceFilter.selectedOption(null);
        this.getTemplateViewModel().imageHasWaterMarkFilter.selectedOption(null);
        this.getTemplateViewModel().uploadDateFilter.selectedOption(null);

    }

    public onClickScrollRight(idElement){

        // scroll right
        document.getElementById(idElement).scrollLeft += 50;
    }

    public setMode(mode){

        this.getTemplateViewModel().mode(mode);
        if(mode == "single-select"){
            this.getTemplateViewModel().selectedTab("images");
        }else{


        }
    }

    public getMode(){

        return this.getTemplateViewModel().mode();
    }

    public setMustInsertInGallery(value){
        this.getTemplateViewModel().mustInsertInGallery(value)
    }

    public getMustInsertInGallery(){
        return this.getTemplateViewModel().mustInsertInGallery()
    }

    public setTarget(target){

        this.getTemplateViewModel().target(target);
    }

    public getTarget(){

        return this.getTemplateViewModel().target();
    }

    public setIsImageOptimizable(isImageOptimizable: boolean): void {
        this.getTemplateViewModel().isImageOptimizable(isImageOptimizable);
        this.imageEdit.setIsImageOptimizable(isImageOptimizable);
        this.imageView.setIsImageOptimizable(isImageOptimizable);
        this.galleryEdit.setIsImageOptimizable(isImageOptimizable);
        this.galleryView.setIsImageOptimizable(isImageOptimizable);
    }

    public isImageOptimizable(): boolean {
        return this.getTemplateViewModel().isImageOptimizable();
    }

    public onClickListSubMenu(data, value){

        //open selected one
        let imageListElement = document.getElementById(`${value}` + data.id);
        if(imageListElement.classList.contains("is-showing")){
            imageListElement.classList.remove("is-showing");
        }else{
            imageListElement.classList.add("is-showing");
        }
    }

    public onClickLastAddedSubMenu(data){

        let lastAddedElement = document.getElementById("last_added_" + data.id);
        if(lastAddedElement.classList.contains("is-showing")){
            lastAddedElement.classList.remove("is-showing");
        }else{
            lastAddedElement.classList.add("is-showing");
        }

    }

    public onClickScrollLeft(idElement){

        //scroll left
        document.getElementById(idElement).scrollLeft -= 50;
    }

    protected onClickCancel(){

        this.deselectAllImages();
        this.resetRecentImages();
        this.hide();
        this.caller.reset();
    }

    protected onClickMinimizeSelectionPanel(){

        let isSelectionShown = this.getTemplateViewModel().isSelectionShown();
        this.getTemplateViewModel().isSelectionShown(!isSelectionShown);
    }

    protected onClickImageTab(){

        // this.imageView.hide();
        this.galleryView.hide();
        this.getTemplateViewModel().selectedTab("images");
    }

    protected onClickGalleryTab(){
        this.imageView.hide();
        this.caller.getGalleryData();
        this.getTemplateViewModel().selectedTab("galleries");
    }


    protected onClickImagesInContentTab(){

        this.imageView.hide();
        this.galleryView.hide();
        this.getTemplateViewModel().selectedTab("images-in-content");
        let target = this.getTemplateViewModel().target();
        this.caller.getImagesInContent(target);
    }

    public getSelectedImages(){

        return this.getTemplateViewModel().selectedImages();
    }

    public setSelectedImages(data){

        this.getTemplateViewModel().selectedImages(data);

    }

    public getSelectedImagesMarkup(){

        return this.getTemplateViewModel().selectedImagesMarkup();

    }

    public setSelectedImagesMarkup(markup){

        this.getTemplateViewModel().selectedImagesMarkup(markup);

    }

    public getSelectedTab(){

        return this.getTemplateViewModel().selectedTab();
    }

    public isInsertAsGrid(){
        let selected_tab = this.getTemplateViewModel().selectedTab()
        return  selected_tab === 'images' || selected_tab === 'images-in-content' || selected_tab === 'galleries' ? 'grid_view': ''
    }

    public saveGallery(gallery, insert, param){
        this.caller.saveGallery(gallery, insert, param);
    }

    public saveImages(images, insert, param, type, widget){
        this.caller.saveImages(images, insert, param, type, widget);
    }

    protected onClickDownload(data){

        let url = data.url.split("?")[0];
        let name = data.name;
        this.downloadFile(url, name);
    }

    public addToGallery(image){

        let selectedGallery = this.getTemplateViewModel().selectedGallery();

        if(selectedGallery != null){

            this.addToSelectedGallery(image);

        }else{
            //add to new gallery - go right to the add new gallery
            let gallery = {
                id: null,
                name: null,
                description: null,
                images: [image]
            }

            this.editGallery(gallery);

        }
    }


    protected onClickAddToGallery(data){

        this.addToGallery(data);
    }

    public setRatios(ratios){

        this.ratioFilter.setOptions(ratios);
    }

    public setOrientations(orientations){

        this.orientationFilter.setOptions(orientations);
    }

    public setUploadSources(uploadSources, selectedUploadSource){

        this.uploadSourceFilter.setOptions(uploadSources);
        this.getTemplateViewModel().uploadSourceFilter.setSelectedOption(selectedUploadSource);
    }

    public setIdBrand(idBrand){

        this.getTemplateViewModel().idBrand(idBrand);
    }

    public setTotalCount(totalCount){
        this.getTemplateViewModel().totalCount(totalCount);
    }

    protected addToSelectedGallery(image){

        let selectedGallery = this.getTemplateViewModel().selectedGallery();
        let imageExists = selectedGallery.images.find(i => i.id == image.id);
        if(!imageExists){

            image.unsaved = true;
            selectedGallery.images.push(image);
            selectedGallery.unsaved = true;
        }

        this.getTemplateViewModel().selectedGallery(selectedGallery);
        this.showGalleryArrows();
        this.showImageArrows();
    }

    protected onClickAddToGalleryAll(){
        let viewModel = this.getTemplateViewModel();
        let selectedImages = viewModel.selectedImages();
        let selectedGallery = viewModel.selectedGallery();

        if(selectedGallery != null){
            for (let image of selectedImages){

                this.addToSelectedGallery(image);
            }
        }else{

            //create new gallery with the selected images
            let gallery = {
                id: null,
                name: null,
                description: null,
                images: selectedImages
            }

            this.editGallery(gallery);
        }

        this.deselectAllImages();
    }

    public downloadFile(fileUrl, name){
        /*, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'no-cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached// include, *same-origin, omit
            headers: {
                'Content-Disposition': 'attachment'
            }}*/


        fetch(fileUrl)
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                let extension = fileUrl.split('.').pop();
                // the filename you want
                a.download = name + '.' + extension;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                //alert('your file has downloaded!'); // or you know, something with better UX...
            })
            .catch(() => alert('file download failed!'));
    }

    public getFile(url, name, download){
        var element = document.createElement('a');
        element.setAttribute('href', url);
        if(download){
            let extension = url.split('.').pop();
            element.setAttribute('download', name + '.' + extension);
        }else{
            element.setAttribute('target', '_blank');
        }
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected onClickRemoveSelectedImage(data){

        this.removeItemFromArray(data, this.getTemplateViewModel().selectedImages);

        this.removeImageListSelection(data);

        this.removeRecentImageListSelection(data);

        this.removeInContentListSelection(data);

        this.showGalleryArrows();
        this.showImageArrows();
    }

    public removeImageListSelection(image){
        let imageResults = this.getTemplateViewModel().imageResults;
        let i = imageResults().find(i => i.id === image.id);
        if(i){
            i.selected = false;
            imageResults.refresh(i);
        }
    }

    public removeInContentListSelection(image){
        let imagesInContent = this.getTemplateViewModel().imagesInContent;
        let i = imagesInContent().find(i => i.id === image.id);
        if(i){
            i.selected = false;
            imagesInContent.refresh(i);
        }

    }

    public removeRecentImageListSelection(image){
        let recentImages = this.getTemplateViewModel().recentImages;
        let i = recentImages().find(i => i.id === image.id);
        if(i){
            i.selected = false;
            recentImages.refresh(i);
        }

    }

    protected onClickRemoveGalleryImage(data){

        let selectedGallery = this.getTemplateViewModel().selectedGallery();

        if(selectedGallery.images.length > 1){
            let index = selectedGallery.images.findIndex(i => i.id === data.id);
            if(index != -1){
                selectedGallery.images.splice(index,1);
            }
        }

        selectedGallery.unsaved = true
        this.getTemplateViewModel().selectedGallery(selectedGallery);
        this.showGalleryArrows();
        this.showImageArrows();
    }

    protected onClickAdd(){

        this.addImage();
    }

    protected addImage(){

        this.resetValidationMessages();
        this.imageAdd.show();
    }

    public resetValidationMessages() {

        this.imageAdd.validationsList.clearMessages();
        this.imagesBulkEdit.validationsList.clearMessages();
    }

    protected onClickQuickInsert(param, image){

        this.deselectAllImages();

        image.isMobileOptimized = (param == '' && !image.isWaterMark && image.isLandscape && this.isImageOptimizable());
        this.insertImage(image, param);
    }

    protected onClickDeselectAll(){

        this.deselectAllImages();
    }

    public deselectAllImages(){

        let selectedImages = this.getTemplateViewModel().selectedImages();
        let imageResults = this.getTemplateViewModel().imageResults;
        let recentImages = this.getTemplateViewModel().recentImages;
        for(let selectedImage of selectedImages){

            this.removeImageListSelection(selectedImage);
            this.removeRecentImageListSelection(selectedImage);
            this.removeInContentListSelection(selectedImage);
        }

        this.getTemplateViewModel().selectedImages([]);
        this.showImageArrows();
        this.showGalleryArrows();
    }

    public resetRecentImages(): void {

        this.getTemplateViewModel().recentImages([]);
    }

    public deleteImage(data){

        if (confirm("Are you sure you want to delete this image?") == true) {
            this.caller.deleteImage(data);

            //remove from recent images
            this.removeItemFromArray(data,this.getTemplateViewModel().recentImages);

            //remove from selected images
            this.removeItemFromArray(data, this.getTemplateViewModel().selectedImages);

            this.galleryView.hide();
            this.galleryEdit.hide();
            this.hideEditedImageWhenDeleted(data.id);
            this.hideViewedImageWhenDeleted(data.id);
            //this.hide();
        }
    }

    protected onClickDelete(data){

        this.deleteImage(data);
    }



    protected removeItemFromArray(item, array){
        let index = array().findIndex(i => i.id === item.id);
        if(index != -1){
            array.splice(index,1);
            array.refresh(array);
        }
    }

    protected onClickInsertIndividually(){

        let viewModel = this.getTemplateViewModel();
        let selectedImages = viewModel.selectedImages();

        for (let image of selectedImages){
            image.isMobileOptimized = (this.isImageOptimizable() && image.isLandscape && !image.isWaterMark);
            this.insertImage(image, '');
        }
    }

    protected onClickInsertImageGroupTag(param, data, $extra_option = 'grid_view'){

        let viewModel = this.getTemplateViewModel();
        let selectedImages = viewModel.selectedImages();

        let target = this.getTemplateViewModel().target();
        let markup = this.buildImageGroupTag(selectedImages, $extra_option);
        this.caller.onClickInsertImageGroupTag(selectedImages, target, markup);
        this.hide();
    }

    // @TODO this is duplicated in article.. add a new class?
    protected buildImageGroupTag(images, extra_option = ''): string {
        let css = `emaki-imgGroup ${extra_option}`.trim()
        let imageGroupTag = `<div class="${css}">`;

        for (let image of images) {
            let imgTag = this.buildImageTag(image, false, extra_option);
            imageGroupTag = imageGroupTag + imgTag;
        }

        imageGroupTag = imageGroupTag + '</div>'

        return imageGroupTag;
    }

    protected buildImageTag(image, addCaption, extra_option): string {
        let imgTag = '<img ';
        imgTag += 'src="' + image.url + '" ';
        if (image.altText != null) {
            imgTag += 'alt="' + image.altText + '" ';
        } else {
            imgTag += 'alt="" ';
        }
        imgTag += ' width=' + image.width + ' height=' + image.height + ' />';

        //add caption
        if (addCaption && image.caption != null && image.caption.trim() != "") {
            imgTag = '[caption]' + imgTag + ' ' + image.caption + '[/caption]';
        }

        if(extra_option){
            imgTag = `<div class="emaki-imgGroup emaki-imgSingle grid_view">${imgTag}</div>`
        }

        return imgTag;
    }

    protected onClickInsertGalleryImagesIndividually(data){

        let images = data.images;

        for (let image of images){
            image.isMobileOptimized = (this.isImageOptimizable() && image.isLandscape && !image.isWaterMark);
            this.insertImage(image, '');
        }
    }

    protected onClickInsertAll(param, data){
        let viewModel = this.getTemplateViewModel();
        let selectedImages = viewModel.selectedImages();

        this.insertImages(selectedImages, param);

        this.deselectAllImages();
    }

    public insertImage(image, extra_mode){

        let target = this.getTemplateViewModel().target();
        this.caller.insertImage(image, target, extra_mode);
        this.hide();
    }

    public insertImages(images, extra_mode){

        let target = this.getTemplateViewModel().target();
        this.caller.insertImages(images, target, extra_mode);
        this.hide();
    }

    protected onClickInsert(image){

        this.insertImage(image, '');
    }

    protected onClickInsertGallery(param, data){

        let gallery = data;
        if(data.selectedGallery){
            gallery = data.selectedGallery();
        }

        this.saveGallery(gallery, false, param);
        this.insertGallery(gallery, param);
    }

    protected onClickSaveGallery(data){

        let gallery = data;
        if(data.selectedGallery){
            gallery = data.selectedGallery();
        }

        this.saveGallery(gallery, false, '');
    }

    protected onClickCancelGallery(data){

        this.resetGallery();
    }

    protected resetGallery(){

        //reset the gallery to how it was when selected
        let originalSelectedGallery = ko.toJS(this.getTemplateViewModel().originalSelectedGallery());
        this.getTemplateViewModel().selectedGallery(originalSelectedGallery);

        /*let galleryResults = this.getTemplateViewModel().galleryResults;
        let gallery = galleryResults().find(g => g.id == originalSelectedGallery.id);
        if(gallery){
            gallery = originalSelectedGallery;
            galleryResults.refresh(gallery);
        }*/

    }

    public insertGallery(gallery, extra_option){
        let target = this.getTemplateViewModel().target();
        this.caller.insertGallery(gallery, target, extra_option);
        this.hide();
    }

    protected onClickEdit(data){
        this.getImageById(data.id, 'edit');
    }

    protected onClickEditGallery(data){
        let gallery = data;
        if(data.selectedGallery){
            gallery = data.selectedGallery();
        }
        this.editGallery(gallery);
    }

    protected onClickViewGallery(data){

        let gallery = data;
        if(data.selectedGallery){
            gallery = data.selectedGallery();
        }
        this.viewGallery(gallery);
    }

    public viewGallery(gallery){

        this.galleryView.setGallery(gallery);
        this.galleryView.show();
    }

    protected onClickDeselectGallery(){

        this.resetGallery();

        let selectedGallery = this.getTemplateViewModel().selectedGallery();
        let galleryResults = this.getTemplateViewModel().galleryResults;

        let gallery = galleryResults().find(g => g.id == selectedGallery.id);
        if(gallery){
            gallery.selected = false;
            galleryResults.refresh(gallery);
        }

        this.getTemplateViewModel().selectedGallery(null);
        this.showImageArrows();
        this.showGalleryArrows();
    }

    protected onClickView(data){
        this.getImageById(data.id);
    }

    /**
     * Make a GET request to the /images/get/:id endpoint,
     * and return the response as a promise.
     * @param {number} idImage The id of the image to retrieve
     * @param action
     * @returns {Promise<*>} The response from the server
     */
    public async getImageById(idImage: number, action = null): Promise<any> {

        if (this.caller.callerModule && typeof this.caller.callerModule.getImageById === 'function') {
            this.caller.callerModule.getImageById(idImage);
            return;
        }

        if (this.caller.imageXHRHdl) {
            this.caller.imageXHRHdl.cancelAndReset();
        }

        let imageUrl = this.caller.getUrlBase() + '/images/get/' + idImage;
        let formReq_url: string = imageUrl.replace('//','/');
        let formReq_params: Array<Array<string>> = [];

        this.caller.imageXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.caller.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        switch(action){
            case 'edit':
                this.caller.imageXHRHdl.onReadyStateFunction = this.onGetImageDataEdit;
                this.caller.imageXHRHdl.execute();
                break;
            default:
                this.caller.imageXHRHdl.onReadyStateFunction = this.onGetImageData;
                this.caller.imageXHRHdl.execute();
                break;
        }

    }

    protected onGetImageDataEdit(req, obj) {

        if (this && typeof this.onGetImageDataEdit === 'function') {
            this.onGetImageDataEdit(req, obj);
            return;
        }

        return function () {
            obj.caller.callerModule.manageResponse(req, obj, function () {
                if (req.request.readyState === XMLHttpRequest.DONE) {
                    let responseParsed = JSON.parse(req.request.response);
                    if(undefined !== responseParsed.data ){
                        obj.editImage(responseParsed.data.image);
                    }
                }else {
                    console.error('an error occurred while retrieving the image data');
                }
            })

        }

    }

    protected onGetImageData(req, obj) {
        if (this && typeof this.onGetImageData === 'function') {
            this.onGetImageData(req, obj);
            return;
        }

        return function () {
            obj.caller.callerModule.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if(undefined !== responseParsed.data ){
                    obj.viewImage(responseParsed.data.image);
                }
            })
        }

    }

    public viewImage(image){

        this.imageView.setImage(image);
        this.imageView.setMode(this.getTemplateViewModel().mode());
        this.imageView.show();
    }

    public hideEdit(){

        this.imageEdit.hide();
    }

    public setImageResults(imageResults){


        if(this.getTemplateViewModel().imagePagination.pageNumber() == 1){
            this.getTemplateViewModel().imageResults([])
        }
        if(imageResults.length > 0) {
            let decoratedImages = this.decorateImages(imageResults);
            let images = this.getTemplateViewModel().imageResults().concat(decoratedImages);
            this.getTemplateViewModel().imageResults(images);

            this.imageNextpageRequested = false;
            if (!this.imageLoadEnable) {
                this.enableImageWaypoint();
            }
        }
    }

    public decorateImages(images) {
        let docoratedImages = [];
        images.forEach((i) => {
            i['isMobileOptimized'] = false;
            docoratedImages.push(i);
        });

        return docoratedImages;
    }

    public setImagesInContent(imagesInContent){
        let decoratedImages = this.decorateImages(imagesInContent);
        this.getTemplateViewModel().imagesInContent(decoratedImages);
    }

    public getSelectedGallery(){

        return this.getTemplateViewModel().selectedGallery();
    }

    public onGallerySaveReturn(gallery, insert, param){

        this.selectGallery(gallery);
        this.updateAllGalleryReferences(gallery);
        if(insert && this.getMustInsertInGallery()){
            this.insertGallery(gallery, param);
        }
        this.setMustInsertInGallery(true)
    }

    public onImageSaveReturn(images, insert, extra_option, insertType) {

        var collection = [];

        images.forEach((f) => {
            if (f.newImage) {
                this.addNewImage(f.image);
            }

            this.updateAllImageReferences(f.image);

            if (insert && insertType == 'image') {
                f.image.isMobileOptimized = (this.isImageOptimizable() && f.isMobileOptimized);

                this.insertImage(f.image, extra_option);
            }else{
                collection.push(f.image);
            }
        });

        //insert as group
        if(collection.length > 0 && insertType == 'group'){
            this.insertImages(collection, extra_option)
        }

        this.keepAllowedRecentImages();
    }


    protected selectGallery(gallery){
        //copy it so we can revert it to original

        let galleryCopy = ko.toJS(gallery);
        let galleryCopy2 = ko.toJS(gallery);
        //let galleryCopy = {...gallery};
        /*let galleryCopy = {
            id: gallery.id,
            name: gallery.name,
            description: gallery.description,
            images: {...gallery.images}
        }*/
        this.getTemplateViewModel().originalSelectedGallery(galleryCopy);
        this.getTemplateViewModel().selectedGallery(galleryCopy2);
        this.showGalleryArrows();
        this.showImageArrows();
    }

    public setGalleryResults(galleryResults){
        if(galleryResults.length > 0) {
            for(let gallery of galleryResults){
                gallery.isUnderEmbargo = false;
                for(let image of gallery.images){
                    if(image.isUnderEmbargo){
                        gallery.isUnderEmbargo = true;
                        break;
                    }
                }
            }
            if(this.getTemplateViewModel().galleryPagination.pageNumber() == 1){
                this.getTemplateViewModel().galleryResults([])
            }
            galleryResults.forEach((gi) => {
                gi['images'] = this.decorateImages(gi['images']);
            });

            let galleries = this.getTemplateViewModel().galleryResults().concat(galleryResults);
            this.getTemplateViewModel().galleryResults(galleries);

            this.galleryNextpageRequested = false;
            if (!this.galleryLoadEnable) {
                this.enableGalleryWaypoint();
            }
        }
    }

    public editImage(image, mode=""){
        this.hideImageAdd();
        //this.imageView.hide();
        this.imageEdit.setImage(null);
        this.imageEdit.setImage(image);
        this.imageEdit.setMode(mode);
        this.imageEdit.show();
    }

    public handleBulkImages(images){
        this.hideImageAdd();
        this.imagesBulkEdit.setMode(this.getTemplateViewModel().mode())
        this.imagesBulkEdit.setImages(images);
        this.imagesBulkEdit.show();
    }

    public selectImage(image){
        this.imageView.hide();
        let imageResults = this.getTemplateViewModel().imageResults;

        let result = imageResults().find(i => i.id == image.id);
        if(result){
            result.selected = true;
            imageResults.refresh(result);
        }

        this.updateSelectedImages(image);
        this.showGalleryArrows();
        this.showImageArrows();
    }

    protected showImageArrows(){

        let selectedGallery = this.getTemplateViewModel().selectedGallery();
        let selectedImages = this.getTemplateViewModel().selectedImages();

        let len = 9;
        if(selectedGallery){
            len = 5
        }

        if(selectedImages.length < len){
            this.getTemplateViewModel().isImageArrowsShown(false);
        }else{
            this.getTemplateViewModel().isImageArrowsShown(true);
        }
    }

    protected showGalleryArrows(){

        let selectedGallery = this.getTemplateViewModel().selectedGallery();
        let selectedImages = this.getTemplateViewModel().selectedImages();

        let len = 9;
        if(selectedImages.length > 0){
            len = 5
        }
        if(selectedGallery && selectedGallery.images.length < len){
            this.getTemplateViewModel().isGalleryArrowsShown(false);
        }else{
            this.getTemplateViewModel().isGalleryArrowsShown(true);
        }
    }



    public editGallery(gallery){
        this.galleryEdit.setGallery(gallery);
        this.galleryEdit.show();
    }

    protected addNewImage(image){
        this.addToRecentImages(image);
        this.galleryEdit.addImage(image);
    }

    protected updateAllImageReferences(image){
        //update all places that are currently using this image


        //recently uploaded
        let recentImages = this.getTemplateViewModel().recentImages;
        this.refreshArrayItem(recentImages(), image);
        recentImages.refresh(image);

        //list results
        let imageResults = this.getTemplateViewModel().imageResults;
        this.refreshArrayItem(imageResults(), image);
        imageResults.refresh(image);

        //selected images
        let selectedImages = this.getTemplateViewModel().selectedImages;
        this.refreshArrayItem(selectedImages(), image);
        selectedImages.refresh(image);

        //selected images
        let imagesInContent = this.getTemplateViewModel().imagesInContent;
        this.refreshArrayItem(imagesInContent(), image);
        imagesInContent.refresh(image);

        //gallery results
        let galleryResults = this.getTemplateViewModel().galleryResults;

        for(let result of galleryResults()){
            this.refreshArrayItem(result.images,image);
            galleryResults.refresh(result);
        }

        //image view
        this.imageView.setImage(image);


        //gallery view
        this.galleryView.refreshImage(image);

        //gallery edit
        this.galleryEdit.refreshImage(image);

    }

    protected updateAllGalleryReferences(gallery){
        //update all places that are currently using this gallery

        //gallery results
        let galleryResults = this.getTemplateViewModel().galleryResults;
        console.log("galleryResults 3", galleryResults());
        this.refreshArrayItem(galleryResults(),gallery);
        galleryResults.refresh(gallery);

        //gallery view
        this.galleryView.setGallery(gallery);
    }

    protected refreshArrayItem(array, item){

        let index = array.findIndex(i => i.id == item.id);
        if(~index){
            array[index] = item;
        }
    }

    protected addToRecentImages(image){
        let recent = this.getTemplateViewModel().recentImages;
        recent().unshift(image);
        recent.refresh(image,0);
    }

    public showUploadError(){

        this.imageAdd.showUploadError();
    }

    protected onClickGallery(gallery){

        let selectedGallery = this.getTemplateViewModel().selectedGallery();
        let galleryResults = this.getTemplateViewModel().galleryResults;

        gallery.selected = !gallery.selected;

        this.getTemplateViewModel().selectedGallery(null);
        if(gallery.selected){
            //deselect previous gallery - only one at a time
            if(selectedGallery && selectedGallery.id != gallery.id){
                let previousGallery = galleryResults().find(g => g.id == selectedGallery.id);
                if(previousGallery){
                    previousGallery.selected = false;
                    galleryResults.refresh(previousGallery);
                }
            }

            this.selectGallery(gallery);
        };

        galleryResults.refresh(gallery);
    }

    protected onClickImage(image){

        image.selected = !image.selected;

        this.updateSelectedImages(image);
        this.showGalleryArrows();
        this.showImageArrows();

        let recentImages = this.getTemplateViewModel().recentImages;
        let recentImage = recentImages().find(i => i.id === image.id);
        if(recentImage){
            recentImage.selected = image.selected;
            recentImages.refresh(recentImage);
        }

        let imageResults = this.getTemplateViewModel().imageResults;
        imageResults.refresh(image);

        let imagesInContent = this.getTemplateViewModel().imagesInContent;
        imagesInContent.refresh(image);
    }

    protected onClickRecentImage(image){

        image.selected = !image.selected;

        this.updateSelectedImages(image);

        let imageResults = this.getTemplateViewModel().imageResults;
        let imageResult = imageResults().find(i => i.id === image.id);
        if(imageResult){
            imageResult.selected = image.selected;
            imageResults.refresh(imageResult);
        }

        let imagesInContent = this.getTemplateViewModel().imagesInContent;
        let imageInContentResult = imagesInContent().find(i => i.id === image.id);
        if(imageInContentResult){
            imageInContentResult.selected = image.selected;
            imagesInContent.refresh(imageInContentResult);
        }

        let recentImages = this.getTemplateViewModel().recentImages;
        recentImages.refresh(image);

    }

    protected updateSelectedImages(image){
        let selectedImages = this.getTemplateViewModel().selectedImages;
        if(image.selected){

            let alreadySelected = selectedImages().find(i => i.id === image.id);
            if(!alreadySelected){
                selectedImages().push(image);
            }

        }else{
            let index = selectedImages().findIndex(i => i.id === image.id);
            if(index != -1){
                selectedImages.splice(index,1);
            }
        }
        //debugger;
        selectedImages.refresh(image);

    }

    protected setSelectedImage(image){

        this.getTemplateViewModel().selectedImage(image);
    }

    protected onAddFiles(event){
        this.caller.handleFiles(event.target.files);
    }

    protected onDropFile(e){

        this.imageAdd.show();
        this.imageAdd.onDropFile(e);

        /*let dt = e.dataTransfer;
        let files = dt.files;
        this.caller.handleFiles(files);*/
        //this.getTemplateViewModel().isPickerShown(false);
    }

    public show(){

        let mode = this.getTemplateViewModel().mode();

        this.resetValidationMessages();

        if(!document.body.classList.contains("is-fixed")){

            document.body.classList.add("is-fixed");
        }

        this.getTemplateViewModel().selectedTab('images');

        if (mode !== 'multi-select-no-gallery') {
            this.getTemplateViewModel().selectedImages([]);
        }

        this.getTemplateViewModel().selectedGallery(null);
        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        document.body.classList.remove("is-fixed");
        this.getTemplateViewModel().isShown(false);
        this.resetPagination();
        this.resetFilter();
    }

    public enableImageWaypoint() {

        var div = document.getElementById('image-results-list');
        let huit_neuf_this = this;

        var locked = false;
        var lastCall = 0;

        if(div) {
            div.addEventListener("scroll", function (event) {
                if(locked) return;

                if (lastCall) clearTimeout(lastCall);
                lastCall = setTimeout(() => {
                    if(huit_neuf_this) {
                        huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this, div);
                    }
                }, 200);
                if (document.body.classList.contains("is-fixed") && div.scrollTop!= 0 && div.scrollTop + div.clientHeight >= (div.scrollHeight - 100) && !huit_neuf_this.imageNextpageRequested) {
                   // if (huit_neuf_this.getTemplateViewModel().imagePagination.pageNumber() < huit_neuf_this.getTemplateViewModel().imagePagination.pageMax()) {
                        
                        huit_neuf_this.getTemplateViewModel().imagePagination.pageNumber(huit_neuf_this.getTemplateViewModel().imagePagination.pageNumber() + 1)
                        huit_neuf_this.getTemplateViewModel().imagePagination.reuseTotalCount = huit_neuf_this.getTemplateViewModel().imagePagination.totalCount;
                        huit_neuf_this.caller.getImageData();
                        huit_neuf_this.imageNextpageRequested = true;
                   // }
                }

                locked = false;
            });
            this.imageLoadEnable = true;
        }
    }

    private runOnScroll(event, lastCall, locked, huit_neuf_this, div) {

        if(locked) return;

        if (lastCall) clearTimeout(lastCall);
        lastCall = setTimeout(() => {
            if(huit_neuf_this) {
                huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this);
            }
        }, 200);

        locked = false;
    }

    public enableGalleryWaypoint() {

        var div = document.getElementById('gallery-results-list');
        let huit_neuf_this = this;

        var locked = false;
        var lastCall = 0;

        if(div) {
            div.addEventListener("scroll", function (event) {

                if (lastCall) clearTimeout(lastCall);
                lastCall = setTimeout(() => {
                    if(huit_neuf_this) {
                        huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this, div);
                    }
                }, 200);
                if (document.body.classList.contains("is-fixed") && div.scrollTop!= 0 && div.scrollTop + div.clientHeight >= (div.scrollHeight - 100) && !huit_neuf_this.galleryNextpageRequested) {
                 //   if(huit_neuf_this.getTemplateViewModel().galleryPagination.pageNumber() < huit_neuf_this.getTemplateViewModel().galleryPagination.pageMax()) {
                        huit_neuf_this.getTemplateViewModel().galleryPagination.pageNumber(huit_neuf_this.getTemplateViewModel().galleryPagination.pageNumber() + 1)
                        huit_neuf_this.caller.getGalleryData();
                        huit_neuf_this.galleryNextpageRequested = true;
                 //   }
                }
            });
            this.galleryLoadEnable = true;
        }

    }

    protected filterSimpleOnChange(idElement) {
        this.resetPagination();
        this.caller.filterSimpleOnChange(idElement);
    }

    protected filterDropdownOnChange(idElement) {
        this.resetPagination();
        this.caller.filterDropdownOnChange(idElement);
    }

    protected filterSimpleCancel(){
        this.caller.filterSimpleCancel();
    }

    public getTagsSuggestion(keyword, idSourceElement) {
        this.caller.getTagsSuggestion(keyword, idSourceElement);
    }

    public setImagesPagination(pagination){

        this.getTemplateViewModel().imagePagination.totalCount = pagination.totalCount;
        this.getTemplateViewModel().imagePagination.pageMax(pagination.totalPage);
        this.getTemplateViewModel().imagePagination.pageNumber(pagination.currentPage);
    }

    public setGalleryPagination(pagination){

        this.getTemplateViewModel().galleryPagination.pageMax(pagination.totalPage);
        this.getTemplateViewModel().galleryPagination.pageNumber(pagination.currentPage);
    }

    public hideImageAdd(): void {

        this.imageAdd.hide();
    }

    public setNumberOfRecentImages(number: Number): void {

        this.getTemplateViewModel().numberOfRecentImages(number);

    }

    public keepAllowedRecentImages(): void {

        let recentImages = this.getTemplateViewModel().recentImages();
        let numberOfRecentImages =  this.getTemplateViewModel().numberOfRecentImages();
        let recentImagesAllowed = recentImages.slice(0, numberOfRecentImages);

        this.getTemplateViewModel().recentImages(recentImagesAllowed);
    }

    public resetTab(): void {
        this.getTemplateViewModel().selectedTab('images');
    }

    public resetSimpleSearchFilter(): void {
        this.filterSimple.getTemplateViewModel().filterInputClearButton(0);
        this.filterSimple.getTemplateViewModel().filterKeyword("");
    }

    public resetRatioFilter(): void {
        this.ratioFilter.setSelectedOption('All');
    }

    public resetUploadDateFilter(): void {
        this.uploadDateFilter.setSelectedOption('All');
    }

    public resetOrientationFilter(): void {
        this.orientationFilter.setSelectedOption('All');
    }

    public resetUploadSourceFilter(): void {
        this.uploadSourceFilter.setSelectedOption('Network');
    }

    public resetOrderFilter(): void {
        this.getTemplateViewModel().orderByAndDirection('dateCreated_DESC')
    }

    public resetWatermarkFilter(){
        this.imageHasWaterMarkFilter.setSelectedOption(0)
    }

    public clearFilters(): void {

        this.resetTab();
        this.resetSimpleSearchFilter();
        this.resetOrderFilter();
        this.resetOrientationFilter();
        this.resetRatioFilter();
        this.resetUploadSourceFilter();
        this.resetWatermarkFilter();
        this.resetUploadDateFilter();

    }


    public hideViewedImageWhenDeleted(imageId: number): void {
        let viewedImageId = this.imageView.getTemplateViewModel().idImage();

        if (imageId == viewedImageId) {
            this.imageView.hide();
        }
    }


    public hideEditedImageWhenDeleted(imageId: number): void {
        let viewedImageId = this.imageEdit.getTemplateViewModel().idImage();

        if (imageId == viewedImageId) {
            this.imageEdit.hide();
        }
    }

    public showPickerUploadError(): void {
        this.getTemplateViewModel().showPickerUploadError(true);
    }

    public hidePickerUploadError(): void {
        this.getTemplateViewModel().showPickerUploadError(false);
    }

    public imageIsolderThan24Hours(data): boolean {
        let now : any = new Date()
        let imageCreationDate : any = new Date(data.dateCreated)

        return (now - imageCreationDate > imagePicker_template.ONE_DAY)
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
        this.imageEdit.setPermissions(permissions)
        this.imageView.setPermissions(permissions)
        this.galleryView.setPermissions(permissions)
    }


    //Overriding the caller for Helper function
    public setCaller(caller){
        this.caller = caller;
        this.imageEdit.caller = caller;
        this.imageView.caller = caller;
        this.imageAdd.caller = caller;
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template.ts